
const CronogramaUI = () => {
  return (
    <div className=" bg-gray-100">
      
    </div>
  );
};

export default CronogramaUI;